// extracted by mini-css-extract-plugin
module.exports = {"link":"EmployeePopUp__link--uU2Z5","information":"EmployeePopUp__information--1NU-s"};